import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

import SearchComponent from '../../Table/SearchComponent';

import { checkHasPermissions } from '../../../utils';

import permissions from '../../../permissions';
import StyledSelect from '../../Select';
import ListActions from '../../Table/ListActions';

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '1rem',
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
}));

const StyledCommunitySelect = styled(Box)(({ theme }) => ({
  width: '50%',
  [theme.breakpoints.down('sm')]: {
    order: 1,
    flex: 1,
  },
}));

const StyledSearch = styled(Box)(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    order: 3,
    flex: 'auto',
    width: '100%',
  },
}));

const StyledActions = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    order: 2,
  },
}));

const CommunityHeaderComponent = ({
  community,
  onCommunityChange,
  communityOptions,
  search,
  setSearch,
  communityActions,
}) => {
  const { t } = useTransl();
  const theme = useTheme();

  return (
    <StyledContainer>
      <StyledCommunitySelect>
        <StyledSelect
          value={community}
          onChange={onCommunityChange}
          options={communityOptions}
          placeholder={t('community.chooseCommunity')}
          disableClearable
        />
      </StyledCommunitySelect>
      <StyledSearch>
        <SearchComponent
          value={search}
          onChange={setSearch}
          placeholder={t('community.searchCommunity')}
        />
      </StyledSearch>
      {communityActions?.length > 0 && (
        <StyledActions>
          <ListActions
            color={theme.palette.success.main}
            disabled={!checkHasPermissions(permissions.create_community_post)}
            actions={communityActions}
            title={t('actions.addNew')}
          />
        </StyledActions>
      )}
    </StyledContainer>
  );
};

CommunityHeaderComponent.propTypes = {
  community: PropTypes.instanceOf(Object).isRequired,
  onCommunityChange: PropTypes.func.isRequired,
  communityOptions: PropTypes.instanceOf(Array).isRequired,
  setSearch: PropTypes.func.isRequired,
  communityActions: PropTypes.instanceOf(Array).isRequired,
  search: PropTypes.string,
};

export default CommunityHeaderComponent;
